import React, { useReducer } from 'react';
import { StyleSheet, ScrollView, View, SafeAreaView, Platform } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import { selectTripsFilters } from '../../store/selectors/mytrips.selector';
import produce from 'immer';

import OptionNavigate from '../OptionNavigate';
import { CommonStyles, CommonProperties, Color } from '../../styles';
import RowView from '../RowView';
import BaseText from '../BaseText';
import Button, { BUTTON_TYPES } from '../Button';
import BottomButton from '../BottomButton';
import { filterTrips } from '../../store/actions/mytrips';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import { Screens } from '../../constants/ScreenNames';

import { useBackButtonEffect } from '../../utils/useBackButtonEffect';
const CHECK = 'CHECK';
const CHECK_ALL = 'CHECK_ALL';

const reducer = (state, action) => {
  switch (action.type) {
    case CHECK:
      return produce(state, (draft) => {
        const index = draft.findIndex((trip) => action.code === trip.Code);
        draft[index].Checked = !state[index].Checked;
      });
    case CHECK_ALL:
      return produce(state, (draft) => {
        draft.forEach((item) => {
          item.Checked = action.checked;
        });
      });
    default:
      return state;
  }
};

const isAllChecked = (filters) => !filters.some((trip) => !trip.Checked);
const isValidFilters = (filters) => filters.some((trip) => trip.Checked);
const TripFilterModal = ({ navigation }) => {
  const { tKey } = useComponentTKey('MainNavigator');
  const { t } = useTranslation([i18nNS.common, i18nNS.air]);
  const dispatch = useDispatch();
  const tripFilters = useSelector(selectTripsFilters);
  const [filters, dispatchFilters] = useReducer(reducer, tripFilters);
  const allChecked = isAllChecked(filters);
  const disableButton = !isValidFilters(filters);

  //Back button effect to trips screen
  useBackButtonEffect(navigation, Screens.MyTrips, {
    fromFilterOrTripHubScreen: true,
  });

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView>
        <RowView style={styles.filterHeader}>
          <BaseText style={CommonStyles.h3}>{t(tKey('FilterTrips'))}</BaseText>
          <Button
            style={styles.checkAll}
            type={BUTTON_TYPES.TEXT}
            label={allChecked ? t('air:AirFilterModal.ClearAll') : t('air:AirFilterModal.CheckAll')}
            onPress={() => {
              dispatchFilters({
                type: CHECK_ALL,
                checked: !allChecked,
              });
            }}
          />
        </RowView>
        <BaseText style={styles.title}>{t('Trips')}</BaseText>
        <View style={styles.navigateList}>
          {filters.map((item) => (
            <OptionNavigate
              key={item.Code}
              icon="mark"
              title={item.Code ? `${item.Name} (${item.Code})` : 'Unknown'}
              desc={`${item.locCount} ${item.locCount === 1 ? t('Trip') : t('Trips')}`}
              selected={item.Checked}
              onPress={() => dispatchFilters({ type: CHECK, code: item.Code })}
            />
          ))}
        </View>
      </ScrollView>
      <BottomButton
        onPress={() => {
          if (Platform.OS === 'web') {
            setTimeout(() => {
              navigation.navigate(Screens.MyTrips, {
                fromFilterOrTripHubScreen: true,
              });
            }, 200);
          } else {
            navigation.navigate(Screens.MyTrips, {
              fromFilterOrTripHubScreen: true,
            });
          }
          dispatch(filterTrips(filters, !allChecked));
        }}
        label={t('Apply')}
        disabled={disableButton}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  title: {
    ...CommonProperties.h3,
    ...CommonProperties.py2,
    ...CommonProperties.px3,
  },
  container: {
    flex: 1,
    ...CommonProperties.py3,
  },
  navigateList: {
    backgroundColor: Color.accent,
  },
  filterHeader: {
    backgroundColor: Color.accent,
    justifyContent: 'space-between',
    alignItems: 'center',
    ...CommonProperties.px3,
  },
  checkAll: {
    maxWidth: 120,
    alignItems: 'flex-end',
    ...CommonProperties.px0,
  },
});

export default TripFilterModal;
